/**
 * Stropy dávek nástrojů knihovny médií (`/api/admin/backfill-media/*`). API je vynucuje ve
 * schématech těl (`schemas/media.ts`), admin podle nich skládá dávky dialogu sloučení.
 *
 * Řádky `export const <JMÉNO> = <číslo>;` drž doslova v tomto tvaru: skripty kroků
 * (`scripts/media/spolecne.mjs`, `stropZKodu`) je čtou z textu souboru, protože ze `scripts/`
 * nejde importovat `@ckgo2/shared`.
 */

/** Nejvýš otisků v jednom zápisu `merge-duplicates` (F7.13 „po dávkách“). */
export const MERGE_BATCH_MAX_HASHES = 50;
/** Nejvýš ID v jednom volání `assign-countries`. */
export const ASSIGN_COUNTRIES_BATCH_MAX_IDS = 500;
/** Nejvýš ID v jednom volání `ai-refresh` (opakování AI ohniska a textů nad ID, řez 09). */
export const AI_REFRESH_BATCH_MAX_IDS = 10;
